import { BooleanInput, coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Input, Optional } from "@angular/core";
import { MAT_OPTGROUP, MAT_OPTION_PARENT_COMPONENT, MatOptgroup, MatOption } from "@angular/material/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";
import { SelectFieldComponent } from "../select-field.component";

interface SelectOptionComponentState {
    isCustomContent: boolean;
    viewValue: string | undefined;
}

@Component({
    selector: "dtm-ui-select-option",
    templateUrl: "./select-option.component.html",
    styleUrls: ["./select-option.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        role: "option",
        "[class.mdc-list-item]": "false",
        "[class.mdc-list-item--selected]": "false",
        "[class.mdc-list-item--disabled]": "false",
        "[class.mat-mdc-option]": "false",
        "[class.mat-mdc-option-multiple]": "false",
        "[class.mat-mdc-option-active]": "false",
        "[class.select-option-disabled]": "disabled",
        "[class.select-option-active]": "active",
        "[attr.aria-selected]": "selected",
        "[attr.aria-disabled]": "disabled.toString()",
    },
    providers: [LocalComponentStore],
})
export class SelectOptionComponent extends MatOption {
    protected parentId = this.id;

    @Input() public set isCustomContent(value: BooleanInput) {
        this.localStore.patchState({ isCustomContent: coerceBooleanProperty(value) });
    }

    @Input() public set viewValue(value: string | undefined) {
        this.localStore.patchState({ viewValue: value });
    }

    public override get viewValue(): string {
        const viewValue = this.localStore.selectSnapshotByKey("viewValue");
        if (viewValue) {
            return viewValue;
        }

        if (this.localStore.selectSnapshotByKey("isCustomContent")) {
            return (this.elementRef.nativeElement.querySelector(".custom-content")?.textContent || "").trim();
        } else {
            return (this.elementRef.nativeElement.querySelector(".label")?.textContent || "").trim();
        }
    }

    protected readonly isCustomContent$ = this.localStore.selectByKey("isCustomContent");

    constructor(
        private readonly localStore: LocalComponentStore<SelectOptionComponentState>,
        private readonly elementRef: ElementRef<HTMLElement>,
        changeDetectorRef: ChangeDetectorRef,
        @Optional() @Inject(MAT_OPTION_PARENT_COMPONENT) parent: SelectFieldComponent,
        @Optional() @Inject(MAT_OPTGROUP) group: MatOptgroup
    ) {
        super(elementRef, changeDetectorRef, parent, group);

        this.parentId = parent.id;

        this.localStore.setState({ isCustomContent: false, viewValue: undefined });
    }
}
